import { render, staticRenderFns } from "./d-comment-box-guest.vue?vue&type=template&id=113f25f1&scoped=true&"
import script from "./d-comment-box-guest.vue?vue&type=script&lang=js&"
export * from "./d-comment-box-guest.vue?vue&type=script&lang=js&"
import style0 from "./d-comment-box-guest.vue?vue&type=style&index=0&id=113f25f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113f25f1",
  null
  
)

export default component.exports